import { useQuery } from "@tanstack/react-query";
import client from "shared/utils/axios-config";
import {
  PackageProduct,
  PackageProductList,
  PackageProductMember,
  ProductType,
} from "shared/types";

/* eslint-disable react-hooks/rules-of-hooks */

// Catalog products for the acting business, optionally filtered by type or by
// a class (class_type_id drives the buy-modal cascade and ClassTypePackage).
const getAllProductsByBusinessId = (
  params?: { type?: ProductType; class_type_id?: string },
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: ["product", params ?? {}],
    queryFn: async (): Promise<PackageProductList | undefined> => {
      const res = await client.get(`/v1/product/`, { params });
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
    ...options,
  });
};

const getProductById = (productId?: string) => {
  return useQuery({
    queryKey: ["product", "detail", productId],
    queryFn: async (): Promise<PackageProduct | undefined> => {
      const res = await client.get(`/v1/product/${productId}`);
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
    enabled: !!productId,
  });
};

// Everyone who can book with a product right now, one row per person,
// soonest end date first (both product types).
const getProductMembers = (productId?: string, enabled = true) => {
  return useQuery({
    queryKey: ["product", "members", productId],
    queryFn: async (): Promise<PackageProductMember[] | undefined> => {
      const res = await client.get(`/v1/product/${productId}/members`);
      if (res.status === 200 && !res.data?.error) {
        return res.data.data;
      }
    },
    enabled: !!productId && enabled,
  });
};

export { getAllProductsByBusinessId, getProductById, getProductMembers };
